import AdaptedButton from 'components/Buttons/AdaptedButton'

const DESTRUCTIVE_COLORS = ['#FF3939']

/*
  A ação secundária: o Button `secondary` do @cutilei/ui, com as props de antes do Design System.
  O `color` vermelho (o das exclusões e dos bloqueios) vira o `destructive` da lib. As outras cores,
  `height`, `borderRadius`, `textColor` e `useGradient` não têm mais efeito: todo botão secundário
  tem o mesmo visual. As regras do tipo, do carregando e da largura estão no `AdaptedButton`.
*/
export default function SecondaryButton({
  color,
  height,
  borderRadius,
  textColor,
  useGradient,
  ...props
}) {
  const destructive = DESTRUCTIVE_COLORS.includes(String(color).toUpperCase())
  return <AdaptedButton {...props} variant='secondary' destructive={destructive}/>
}
